"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.RowsLimitError = void 0;
var _ = require("lodash");
var RowsLimitError = /** @class */ (function (_super) {
    __extends(RowsLimitError, _super);
    function RowsLimitError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, RowsLimitError.prototype);
        return _this;
    }
    return RowsLimitError;
}(Error));
exports.RowsLimitError = RowsLimitError;
exports.create = function (gridTop, _a) {
    var rowsLimit = _a.rowsLimit;
    var rowsTops = [gridTop];
    var maxSpanByRow = {};
    var rowsTopsWedgeUnavailable = {};
    var isRowWithContent = function () { return !!maxSpanByRow[rowsTops.length]; };
    var rowsAPI = {
        count: function () { return rowsTops.length; },
        first: function () { return _.first(rowsTops); },
        last: function () { return _.last(rowsTops); },
        get: function (index) { return rowsTops[index]; },
        closeRow: function (rowBottom) {
            if (rowsTops.length + 1 >= rowsLimit) {
                throw new RowsLimitError();
            }
            rowsTops.push(rowBottom);
        },
        getRowAbove: function (y) { return _.findLastIndex(rowsTops, function (value) { return value <= y; }); },
        isWedgePossible: function () { return !rowsTopsWedgeUnavailable[rowsAPI.last()]; },
        setNoWedge: function () {
            rowsTopsWedgeUnavailable[rowsAPI.last()] = true;
        },
        markRowWithContent: function () {
            maxSpanByRow[rowsAPI.count()] = maxSpanByRow[rowsAPI.count()] || 1;
        },
        createExtraRows: function (rowStart, rowBottom) {
            var currRowEnd = rowsAPI.count() + 1;
            var compSpan = currRowEnd - rowStart;
            var maxSpanInArea = _.max(_.times(compSpan, function (n) { return maxSpanByRow[rowStart + n] || 1; }));
            var rowsToAdd = _.max([isRowWithContent() ? 1 : 0, maxSpanInArea - compSpan + 1]);
            if (!_.isUndefined(rowsLimit) && rowsTops.length + rowsToAdd >= rowsLimit) {
                throw new RowsLimitError();
            }
            var spanWithExtraRows = compSpan + rowsToAdd;
            _.times(compSpan, function (n) { return maxSpanByRow[rowStart + n] = spanWithExtraRows; });
            _.times(rowsToAdd, function () {
                rowsAPI.closeRow(rowBottom);
                maxSpanByRow[rowsAPI.count()] = spanWithExtraRows;
            });
        }
    };
    return rowsAPI;
};
//# sourceMappingURL=rowsAPIFactory.js.map